import { FC } from 'react';

interface CenterSpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

export const CenterSpinner: FC<CenterSpinnerProps> = ({ size = 'md' }) => {
  return (
    <div className="h-100 d-flex justify-content-center align-items-center">
      <div className={`spinner spinner-${size}`} />
    </div>
  );
};
